import { useMutation, useQuery, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import type { RequestParams, ApiResponse } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import { PURCHASE_KEYS } from '../lib';
import { PurchaseApi } from '../api';
import type { PurchaseBase, PurchaseById, PurchaseCreatePayload } from './types';

export const usePurchaseList = (params?: RequestParams) => {
  return useQuery<ApiResponseList<PurchaseBase>>({
    queryKey: PURCHASE_KEYS.list(params),
    queryFn: () => PurchaseApi.getList(params),
    placeholderData: keepPreviousData,
  });
};

export const usePurchaseByGroupId = (groupId: string) => {
  return useQuery<ApiResponse<PurchaseById>>({
    queryKey: PURCHASE_KEYS.detail(groupId),
    queryFn: () => PurchaseApi.getByGroupId(groupId),
    enabled: !!groupId,
  });
};

export const useCreatePurchase = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: PurchaseCreatePayload) => PurchaseApi.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PURCHASE_KEYS.all });
    },
  });
};
